<template>
  <div class="m-10">
    <h1 class="text-lg font-bold">累計</h1>
    <ul>
      <li>決済数: {{ props.allPurchases }}回</li>
      <li>模試実施人数: {{ props.allExaminationProgress }}人</li>
    </ul>
    <LineChart
      ref="lineRef"
      :chart-data="getLineData"
      :options="lineOptions" />
    <BarChart
      ref="barRef"
      :chart-data="getPrefecturesData"
      :options="barOptions" />
    <PieChart
      ref="pieRef"
      :chart-data="getSexData"
      :options="sexOptions" />
    <div class="flex items-center">
      <div class="w-2/3">
        <PieChart
          ref="pieRef"
          :chart-data="getJobData"
          :options="jobOptions" />
      </div>
      <div class="h-72 w-1/3 overflow-y-auto pl-10 scrollbar scrollbar-thumb-rounded scrollbar-thumb-black">
        <table class="table-auto w-full">
          <tr class="sticky -top-0.5 bg-gray-300">
            <th class="text-center border px-1 py-2">No.</th>
            <td class="border px-4 py-2">その他（自由記入欄）</td>
          </tr>
          <tr
            v-for="(text, i) in jobOthersText"
            :key="i">
            <th class="bg-gray-100 text-center border px-1 py-2">{{ i + 1 }}</th>
            <td class="border px-4 py-2">{{ text.job_text }}</td>
          </tr>
        </table>
      </div>
    </div>
    <div class="flex items-center">
      <div class="w-2/3">
        <PieChart
          ref="pieRef"
          :chart-data="getServiceYearsCountData"
          :options="serviceYearsOptions" />
      </div>
      <div class="h-72 w-1/3 overflow-y-auto pl-10 scrollbar scrollbar-thumb-rounded scrollbar-thumb-black">
        <table class="table-auto w-full">
          <tr class="sticky -top-0.5 bg-gray-300">
            <th class="text-center border px-1 py-2">No.</th>
            <td class="border px-4 py-2">その他（自由記入欄）</td>
          </tr>
          <tr
            v-for="(text, i) in serviceYearsOthersText"
            :key="i">
            <th class="bg-gray-100 text-center border px-1 py-2">{{ i + 1 }}</th>
            <td class="border px-4 py-2">{{ text.service_years_text }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  defineProps,
  ref,
  computed,
} from 'vue'
import { Chart, registerables } from 'chart.js'
import { LineChart, BarChart, PieChart } from 'vue-chart-3'

const props = defineProps({
  sexCount: {
    type: Array,
    default: () => [],
  },
  jobCount: {
    type: Array,
    default: () => [],
  },
  serviceYearsCount: {
    type: Array,
    default: () => [],
  },
  areaCount: {
    type: Array,
    default: () => [],
  },
  allPurchases: {
    type: Number,
    default: 0,
  },
  purchasesCount: {
    type: Object,
    default: () => {},
  },
  allExaminationProgress: {
    type: Number,
    default: 0,
  },
  jobOthersText: {
    type: Array,
    default: () => [],
  },
  serviceYearsOthersText: {
    type: Array,
    default: () => [],
  },
})

Chart.register(...registerables)

const pieRef = ref()
const lineRef = ref()
const barRef = ref()
const jobOptions = ref({
  responsive: true,
  plugins: {
    legend: {
      position: 'left',
      labels: {
        font: {
          size: 16,
        },
      },
    },
    title: {
      display: true,
      text: '職種比率',
      font: {
        size: 20,
      },
    },
  },
})
const barOptions = ref({
  responsive: true,
  plugins: {
    legend: {
      labels: {
        font: {
          size: 16,
        },
      },
    },
  },
})
const serviceYearsOptions = ref({
  responsive: true,
  plugins: {
    legend: {
      position: 'left',
      labels: {
        font: {
          size: 16,
        },
      },
    },
    title: {
      display: true,
      text: '勤続年数比率',
      font: {
        size: 20,
      },
    },
  },
})
const sexOptions = ref({
  responsive: true,
  plugins: {
    legend: {
      position: 'left',
      labels: {
        font: {
          size: 16,
        },
      },
    },
    title: {
      display: true,
      text: '男女比率',
      font: {
        size: 20,
      },
    },
  },
})
const lineOptions = ref({
  responsive: true,
  plugins: {
    legend: {
      labels: {
        font: {
          size: 16,
        },
      },
    },
  },

})
const lineDate = ref([
  '01/27',
  '01/28',
  '01/29',
  '01/30',
  '01/31',
  '02/01',
  '02/02',
  '02/03',
  '02/04',
  '02/05',
  '02/06',
  '02/07',
  '02/08',
  '02/09',
  '02/10',
  '02/11',
  '02/12',
  '02/13',
  '02/14',
  '02/15',
  '02/16',
  '02/17',
  '02/18',
  '02/19',
  '02/20',
  '02/21',
  '02/22',
])
const purchasesData = ref(new Array(27).fill(0))
const countPurchasesData = () => {
  for (let i = 0; i < lineDate.value.length; i += 1) {
    for (let ii = 0; ii < props.purchasesCount.length; ii += 1) {
      if (lineDate.value[i] === props.purchasesCount[ii].date) {
        const purchasesCountData = props.purchasesCount[ii].count
        purchasesData.value[i] = purchasesCountData
      }
    }
  }
  for (let i = 1; i < purchasesData.value.length; i += 1) {
    purchasesData.value[i] += purchasesData.value[i - 1]
  }
}
countPurchasesData()
const getLineData = computed(() => ({
  labels: lineDate.value,
  datasets: [
    {
      label: '決済済みユーザー数',
      data: purchasesData.value,
      borderColor: '#5DADE2',
      borderWidth: 5,
    },
  ],
}))

const sexData = ref(new Array(3).fill(0))
const countSexData = () => {
  let index
  for (let i = 0; i < 3; i += 1) {
    if (typeof (props.sexCount[i]) === 'undefined') {
      break
    } else {
      index = props.sexCount[i].sex
    }
    sexData.value[index] = typeof (props.sexCount[i]) === 'undefined' ? 0 : props.sexCount[i].sex_count
  }
}
countSexData()
const getSexData = computed(() => ({
  labels: ['男性', '女性', 'その他'],
  datasets: [
    {
      label: '男女比',
      data: sexData.value,
      backgroundColor: [
        '#3498DB',
        '#EC7063',
        '#F5B041',
      ],
      hoverOffset: 4,
    },
  ],
}))

const jobData = ref(new Array(13).fill(0))
const countJobData = () => {
  let index
  for (let i = 0; i < 13; i += 1) {
    if (typeof (props.jobCount[i]) === 'undefined') {
      break
    } else {
      index = props.jobCount[i].job - 1
    }
    jobData.value[index] = typeof (props.jobCount[i]) === 'undefined' ? 0 : props.jobCount[i].job_count
  }
}
countJobData()
const getJobData = computed(() => ({
  labels: [
    '動物看護師（動物病院勤務）',
    '動物看護師（その他勤務）',
    '動物看護師（休職中）',
    'トリマー（動物病院勤務）',
    'トリマー（トリミングサロン勤務）',
    'トリマー（その他勤務）',
    'トリマー（休職中）',
    '動物看護学生（大学在籍）',
    '動物看護学生（専門学校在籍）',
    '高校生以下',
    '獣医師',
    '獣医学生',
    'その他',
  ],
  datasets: [
    {
      data: jobData.value,
      backgroundColor: [
        '#C0392B',
        '#E74C3C',
        '#9B59B6',
        '#2980B9',
        '#3498DB',
        '#1ABC9C',
        '#16A085',
        '#27AE60',
        '#2ECC71',
        '#F1C40F',
        '#F39C12',
        '#E67E22',
        '#D35400',
      ],
    },
  ],
}))

const serviceYearsData = ref(new Array(10).fill(0))
const countServiceYearsData = () => {
  let index
  for (let i = 0; i < 10; i += 1) {
    if (typeof (props.serviceYearsCount[i]) === 'undefined') {
      break
    } else {
      index = props.serviceYearsCount[i].service_years - 1
    }
    serviceYearsData.value[index] = typeof (props.serviceYearsCount[i]) === 'undefined' ? 0 : props.serviceYearsCount[i].service_years_count
  }
}
countServiceYearsData()
const getServiceYearsCountData = computed(() => ({
  labels: [
    '社会人（4年以下）',
    '社会人（5~10年）',
    '社会人（11年~15年）',
    '社会人（16年~20年)',
    '社会人（21年以上）',
    '学生（1年）',
    '学生（2年）',
    '学生（3年）',
    '学生（4年）',
    'その他',
  ],
  datasets: [
    {
      data: serviceYearsData.value,
      backgroundColor: [
        '#C0392B',
        '#E74C3C',
        '#9B59B6',
        '#2980B9',
        '#3498DB',
        '#1ABC9C',
        '#16A085',
        '#27AE60',
        '#2ECC71',
        '#F1C40F',
        '#F39C12',
        '#E67E22',
        '#D35400',
      ],
    },
  ],
}))

const areaCountData = ref(new Array(47).fill(0))
const countAreaCountData = () => {
  let index
  for (let i = 0; i < 47; i += 1) {
    if (typeof (props.areaCount[i]) === 'undefined') {
      break
    } else {
      index = props.areaCount[i].area - 1
    }
    areaCountData.value[index] = typeof (props.areaCount[i]) === 'undefined' ? 0 : props.areaCount[i].area_count
  }
}
countAreaCountData()
const getPrefecturesData = computed(() => ({
  labels: [
    '北海道',
    '青森県',
    '岩手県',
    '宮城県',
    '秋田県',
    '山形県',
    '福島県',
    '茨城県',
    '栃木県',
    '群馬県',
    '埼玉県',
    '千葉県',
    '東京都',
    '神奈川県',
    '新潟県',
    '富山県',
    '石川県',
    '福井県',
    '山梨県',
    '長野県',
    '岐阜県',
    '静岡県',
    '愛知県',
    '三重県',
    '滋賀県',
    '京都府',
    '大阪府',
    '兵庫県',
    '奈良県',
    '和歌山県',
    '鳥取県',
    '島根県',
    '岡山県',
    '広島県',
    '山口県',
    '徳島県',
    '香川県',
    '愛媛県',
    '高知県',
    '福岡県',
    '佐賀県',
    '長崎県',
    '熊本県',
    '大分県',
    '宮崎県',
    '鹿児島県',
    '沖縄県'],
  datasets: [
    {
      label: '都道府県',
      data: areaCountData.value,
      backgroundColor: '#58D68D',
    },
  ],
}))
</script>
